import {createSlice, type PayloadAction} from '@reduxjs/toolkit';
import {fetchNotifications} from './thunk';

export interface Notification {
  id: string;
  title?: string;
  message?: string;
}

interface NotificationState {
  notifications: Notification[];
  hasNewNotification: boolean; // Flag to track new notifications
  notificationCount: number;
  loading: boolean;
  error: string | null;
}
const initialState: NotificationState = {
  notifications: [],
  notificationCount: 0,
  hasNewNotification: false,
  loading: false,
  error: null,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      state.notifications.unshift(action.payload);
      state.hasNewNotification = true; // Set flag when new notification arrives
    },
    markNotificationsAsRead: state => {
      state.hasNewNotification = false; // Reset flag when notifications are viewed
    },
    clearNotifications: state => {
      state.notifications = [];
    },
    updateNotificationCount: (state, action) => {
      state.notificationCount = action.payload; // Reset flag when notifications are viewed
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchNotifications.pending, state => {
        state.loading = true;
        state.error = null; // Reset error state
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        console.log('🚀 ~ .addCase ~ action:', action);
        state.loading = false;
        state.notifications = action.payload.notification;
        state.notificationCount = action.payload.count;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string; // Handle error
      });
  },
});

export const {
  addNotification,
  clearNotifications,
  markNotificationsAsRead,
  updateNotificationCount,
} = notificationSlice.actions;
export default notificationSlice.reducer;
